export enum TicketStatus {
  NEW = 'new',
  PROGRESS = 'progress',
  RESOLVED = 'resolved',
}
